"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*************************************
	Image Utility Functions
*************************************/

function imageDataToCanvas(imageData) {
  var result = document.createElement("canvas");
  result.width = imageData.width;
  result.height = imageData.height;
  var ctx = result.getContext("2d");
  ctx.putImageData(imageData, 0, 0);
  return result;
}
var _default = exports.default = imageDataToCanvas;